import styled from 'styled-components';

interface IContainerProps {
  isApp: boolean;
}

export const Container = styled.main<IContainerProps>`
  background-color: ${({ theme }) => theme.colors.light.color};

  flex: 1;

  display: flex;
  flex-direction: ${({ isApp }) => (isApp ? 'row' : 'column')};

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.light.color};
  flex: 1;

  display: flex;
  flex-direction: column;

  > .wrapper {
    flex: 1;
    padding-top: 2rem;
  }
`;
